// Всплывающая подсказка: через 0,35 с при наведении и сразу при фокусе с клавиатуры (README «Иконки»).
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { useState } from 'react';
import type { ReactElement, ReactNode } from 'react';
import { ShortcutKeys } from './Kbd.tsx';
import type { Shortcut } from './Kbd.tsx';

export const TOOLTIP_DELAY_MS = 350;

export interface TooltipProps {
  /** Текст подсказки. */
  content: ReactNode;
  /** Клавиша действия: «Скрыть меню [», «Главная G затем H». */
  shortcut?: Shortcut;
  side?: 'top' | 'right' | 'bottom' | 'left';
  /** Элемент, к которому относится подсказка; должен принимать ref и обработчики. */
  children: ReactElement;
  /** Не показывать (например, значение не сокращено). Разметка остаётся той же. */
  disabled?: boolean;
}

export function Tooltip({ content, shortcut, side = 'bottom', children, disabled }: TooltipProps) {
  const [open, setOpen] = useState(false);
  return (
    <RadixTooltip.Provider delayDuration={TOOLTIP_DELAY_MS} skipDelayDuration={200}>
      <RadixTooltip.Root open={!disabled && open} onOpenChange={setOpen}>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content side={side} sideOffset={6} className="t-tip-box kp-tip">
            {content}
            {shortcut ? (
              <>
                {' '}
                <ShortcutKeys shortcut={shortcut} />
              </>
            ) : null}
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}
